import {createApp} from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import SvgIconPlugin from '@/plugins/SvgIconPlugin'
import locale from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'

const app = createApp(App);

app.use(store)
    .use(router)
    .use(ElementPlus, {locale})
    .use(SvgIconPlugin, {imports: []})
    .mount('#app')
